import * as t from "io-ts";
import nullable from "./nullable";
import optional from "./optional";
import { withFallback } from "io-ts-types";
const placeT = t.strict({
    countryCode: t.string,
    postcode: t.string,
    city: t.string,
    place: nullable(t.string),
    date: nullable(t.string),
});
export const deferredInvoicesFolderT = t.strict({
    id: t.string,
    name: t.string,
    clientId: t.string,
    deliveryAddressId: withFallback(nullable(t.string), null),
});
export const deferredInvoicesFoldersT = t.array(deferredInvoicesFolderT);
export const moveToFolderReqT = t.strict({
    deferredInvoiceIds: t.array(t.string),
    clientId: t.string,
    folderId: nullable(t.string),
    folderName: nullable(t.string),
});
export const replaceClientReqT = t.strict({
    fromClientId: t.string,
    toClientId: t.string,
});
export const renameFolderReqT = t.strict({
    folderId: t.string,
    name: t.string,
    clientId: t.string,
});
export const updateFolderReqT = t.strict({
    folderId: t.string,
    name: t.string,
    clientId: t.string,
    deliveryAddressId: withFallback(nullable(t.string), null),
});
export const createFolderReqT = t.strict({
    clientId: t.string,
    folderName: t.string,
    deliveryAddressId: withFallback(nullable(t.string), null),
});
export const createConsolidatedInvoiceTypes = ({ decimal, }) => {
    const deferredInvoiceLineT = t.strict({
        invoiceLineId: withFallback(t.string, ""),
        productId: t.string,
        description: nullable(t.string),
        amount: decimal,
        quantity: decimal,
        unitId: nullable(t.string),
        departmentId: nullable(t.string),
        percentage: nullable(decimal),
        discountPercentage: withFallback(nullable(decimal), null),
    });
    const deferredInvoiceT = t.strict({
        id: t.string,
        deliveryId: t.string,
        invoiceRef: nullable(t.string),
        customerContactId: nullable(t.string),
        folderId: nullable(t.string),
        cargoType: withFallback(nullable(t.string), null),
        route: nullable(t.strict({
            id: t.string,
            name: nullable(t.string),
            ref: t.string,
            truckId: nullable(t.string),
            driversIds: withFallback(t.array(t.string), []),
        })),
        cargo: t.strict({
            id: t.string,
            ref: t.string,
            start: placeT,
            stop: placeT,
        }),
        lines: t.array(deferredInvoiceLineT),
    });
    const getClientsResponseT = t.array(t.strict({
        id: t.string,
        name: t.string,
        total: decimal,
        active: t.boolean,
    }));
    const getDeferredInvoicesResponseT = t.strict({
        invoices: t.array(deferredInvoiceT),
        folders: t.array(deferredInvoicesFolderT),
    });
    const getFilterOptionsResponseT = t.array(t.strict({
        cargoType: nullable(t.string),
        truckId: nullable(t.string),
        driverIds: nullable(t.array(t.string)),
    }));
    return {
        deferredInvoiceT,
        getClientsResponseT,
        getDeferredInvoicesResponseT,
        getFilterOptionsResponseT,
    };
};
export const createDeferredInvoiceT = t.strict({
    clientId: t.string,
    customerContactId: optional(t.string),
    deliveryAddressId: optional(t.string),
    invoiceRef: optional(t.string),
    invoiceIds: t.array(t.string),
    groupProducts: t.boolean,
    dueDate: withFallback(nullable(t.string), null),
});
//# sourceMappingURL=consolidated-invoicing.js.map